import * as NeDB from 'nedb';
import { Application } from 'feathers';
import * as createService from 'feathers-nedb';
import { HooksObject } from 'feathers-hooks';
import { dataDirectory } from './common';

export default (
  app: Application,
  name: string,
  hooks?: HooksObject,
  tableName?: string
) => {
  return function() {
    const Model = new NeDB({
      filename: `${dataDirectory()}/${tableName ? tableName : name}.db`,
      autoload: true,
    });
    // const paginate = app.get('paginate');

    const options = {
      name,
      Model,
      paginate: {
        default: 10,
        max: 100
      },
    };
    app.set(`${name}/neDB`, Model);
    app.use(`/${name}`, createService(options));

    const service = app.service(name);
    if (hooks) {
      service.hooks(hooks);
    }
  };
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/NeDBService.ts